/* <countdown-timer> — live's tick logic (custom.js module 634), de-minified
   1:1: same attribute contract (data-end-date "YYYY-MM-DD" + data-end-time
   "HH:MM:SS", parsed as local time), same 1s interval, same zero-padding into
   the [data-digit] spans, same `expired` class + 00:00:00:00 freeze once the
   target passes. Used by sections/countdown.liquid and by the countdown block
   of image-with-text-landingpage.liquid. */

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
  }

  connectedCallback() {
    this.endDate = this.getAttribute('data-end-date');
    this.endTime = this.getAttribute('data-end-time');

    if (!this.endDate || !this.endTime) {
      console.error('Countdown: Missing end date or time');
      return;
    }

    this.targetDateTime = this.parseDateTime(this.endDate, this.endTime);
    if (!this.targetDateTime) {
      console.error('Countdown: Invalid date/time format');
      return;
    }

    this.digitElements = {
      daysTens: this.querySelector('[data-digit="days-tens"]'),
      daysOnes: this.querySelector('[data-digit="days-ones"]'),
      hoursTens: this.querySelector('[data-digit="hours-tens"]'),
      hoursOnes: this.querySelector('[data-digit="hours-ones"]'),
      minutesTens: this.querySelector('[data-digit="minutes-tens"]'),
      minutesOnes: this.querySelector('[data-digit="minutes-ones"]'),
      secondsTens: this.querySelector('[data-digit="seconds-tens"]'),
      secondsOnes: this.querySelector('[data-digit="seconds-ones"]'),
    };

    this.startCountdown();
  }

  disconnectedCallback() {
    this.stopCountdown();
  }

  parseDateTime(dateString, timeString) {
    var dateParts = dateString.split('-');
    if (dateParts.length !== 3) return null;

    var timeParts = timeString.split(':');
    if (timeParts.length !== 3) return null;

    var year = parseInt(dateParts[0], 10);
    var month = parseInt(dateParts[1], 10) - 1;
    var day = parseInt(dateParts[2], 10);
    var hours = parseInt(timeParts[0], 10);
    var minutes = parseInt(timeParts[1], 10);
    var seconds = parseInt(timeParts[2], 10);

    return new Date(year, month, day, hours, minutes, seconds);
  }

  startCountdown() {
    this.updateCountdown();
    this.intervalId = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  stopCountdown() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  updateCountdown() {
    var now = new Date();
    var timeRemaining = this.targetDateTime - now;

    if (timeRemaining < 0) {
      this.stopCountdown();
      this.setAllDigits(0, 0, 0, 0);
      this.classList.add('expired');
      return;
    }

    var days = Math.floor(timeRemaining / 86400000);
    var hours = Math.floor((timeRemaining % 86400000) / 3600000);
    var minutes = Math.floor((timeRemaining % 3600000) / 60000);
    var seconds = Math.floor((timeRemaining % 60000) / 1000);

    this.setAllDigits(days, hours, minutes, seconds);
  }

  setAllDigits(days, hours, minutes, seconds) {
    this.setDigitPair(days, 'days');
    this.setDigitPair(hours, 'hours');
    this.setDigitPair(minutes, 'minutes');
    this.setDigitPair(seconds, 'seconds');
  }

  setDigitPair(value, unit) {
    var padded = String(value).padStart(2, '0');
    var tens = padded[0];
    var ones = padded[1];
    var tensKey = ''.concat(unit, 'Tens');
    var onesKey = ''.concat(unit, 'Ones');
    if (this.digitElements[tensKey]) {
      this.digitElements[tensKey].textContent = tens;
    }
    if (this.digitElements[onesKey]) {
      this.digitElements[onesKey].textContent = ones;
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
